/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Stay_DetailsInputs */

const en_rental_stay_details = /** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay Details`)
};

const es_rental_stay_details = /** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de la Estancia`)
};

const fr_rental_stay_details = /** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails du séjour`)
};

const de_rental_stay_details = /** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufenthaltsdetails`)
};

const id_rental_stay_details = /** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Penginapan`)
};

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const ja_rental_stay_details = en_rental_stay_details;

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const zh_rental_stay_details = en_rental_stay_details;

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const ar_rental_stay_details = en_rental_stay_details;

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const it_rental_stay_details = en_rental_stay_details;

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const ru_rental_stay_details = en_rental_stay_details;

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const pt_rental_stay_details = en_rental_stay_details;

/** @type {(inputs: Rental_Stay_DetailsInputs) => LocalizedString} */
const ko_rental_stay_details = en_rental_stay_details;

/**
* | output |
* | --- |
* | "Stay Details" |
*
* @param {Rental_Stay_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_stay_details = /** @type {((inputs?: Rental_Stay_DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Stay_DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_stay_details(inputs)
	if (locale === "es") return es_rental_stay_details(inputs)
	if (locale === "fr") return fr_rental_stay_details(inputs)
	if (locale === "de") return de_rental_stay_details(inputs)
	if (locale === "ja") return ja_rental_stay_details(inputs)
	if (locale === "zh") return zh_rental_stay_details(inputs)
	if (locale === "ar") return ar_rental_stay_details(inputs)
	if (locale === "id") return id_rental_stay_details(inputs)
	if (locale === "it") return it_rental_stay_details(inputs)
	if (locale === "ru") return ru_rental_stay_details(inputs)
	if (locale === "pt") return pt_rental_stay_details(inputs)
	return ko_rental_stay_details(inputs)
});